import * as React from 'react';
import DecadeHeader from './DecadeHeader';
import DecadeBody, { DECADE_COL_COUNT } from './DecadeBody';
import { createKeyDownHandler } from '../../utils/uiUtil';
export const DECADE_UNIT_DIFF = 10;
export const DECADE_DISTANCE_COUNT = DECADE_UNIT_DIFF * 10;
function DecadePanel(props) {
    const { prefixCls, onViewDateChange, generateConfig, viewDate, operationRef, onSelect, onPanelChange, } = props;
    const panelPrefixCls = `${prefixCls}-decade-panel`;
    // ======================= Keyboard =======================
    operationRef.current = {
        onKeyDown: event => createKeyDownHandler(event, {
            onLeftRight: diff => {
                onSelect(generateConfig.addYear(viewDate, diff * DECADE_UNIT_DIFF), 'key');
            },
            onCtrlLeftRight: diff => {
                onSelect(generateConfig.addYear(viewDate, diff * DECADE_DISTANCE_COUNT), 'key');
            },
            onUpDown: diff => {
                onSelect(generateConfig.addYear(viewDate, diff * DECADE_UNIT_DIFF * DECADE_COL_COUNT), 'key');
            },
            onEnter: () => {
                onPanelChange('year', viewDate);
            },
        }),
    };
    // ==================== View Operation ====================
    const onDecadesChange = (diff) => {
        const newDate = generateConfig.addYear(viewDate, diff * DECADE_DISTANCE_COUNT);
        onViewDateChange(newDate);
        onPanelChange(null, newDate);
    };
    const onInternalSelect = (date) => {
        onSelect(date, 'mouse');
        onPanelChange('year', date);
    };
    return (<div className={panelPrefixCls}>
            <DecadeHeader {...props} prefixCls={prefixCls} onPrevDecades={() => {
            onDecadesChange(-1);
        }} onNextDecades={() => {
            onDecadesChange(1);
        }}/>
            <DecadeBody {...props} prefixCls={prefixCls} onSelect={onInternalSelect}/>
        </div>);
}
export default DecadePanel;
